module.exports = __webpack_public_path__ + "static/media/christian-prayer.4c6554d1.mp3";